import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailX, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { BrandLockup } from "../components/BrandLogo";

export default function Unsubscribe() {
  const q = new URLSearchParams(window.location.search);
  const [state, setState] = useState("ask");
  const [error, setError] = useState("");
  const confirm = async () => {
    setState("busy");
    try {
      await api.post("/nudge/unsubscribe", { u: q.get("u") || "", t: q.get("t") || "" });
      setState("done");
    } catch (e) {
      setError(e?.response?.data?.detail || "Something went wrong. Please try again.");
      setState("ask");
    }
  };
  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center px-5 py-16">
      <div className="gi-card shadow-float w-full max-w-md p-7 text-center" data-testid="unsubscribe-page">
        <div className="flex justify-center mb-6"><BrandLockup /></div>
        {state === "done" ? (
          <>
            <CheckCircle2 className="w-10 h-10 text-success mx-auto" aria-hidden="true" />
            <h1 className="font-display text-2xl font-bold text-ink mt-3" data-testid="unsubscribe-done">You're unsubscribed</h1>
            <p className="text-body mt-2">You won't get the weekly email any more. You can turn it back on any time in My Profile.</p>
          </>
        ) : (
          <>
            <MailX className="w-10 h-10 text-brand mx-auto" aria-hidden="true" />
            <h1 className="font-display text-2xl font-bold text-ink mt-3">Stop the weekly email?</h1>
            <p className="text-body mt-2">You'll stop getting your Monday next steps and progress email.</p>
            {error && <p className="mt-3 text-sm text-danger" data-testid="unsubscribe-error">{error}</p>}
            <button data-testid="unsubscribe-confirm" onClick={confirm} disabled={state === "busy"} className="mt-6 w-full gi-btn gi-btn-primary gi-btn-lg">
              {state === "busy" && <Loader2 className="w-4 h-4 animate-spin" />} Unsubscribe
            </button>
          </>
        )}
        <Link to="/" className="mt-4 inline-block text-sm text-brand hover:underline" data-testid="unsubscribe-home">Go to GetInterviewed</Link>
      </div>
    </div>
  );
}
